// extracted by mini-css-extract-plugin
export var date = "Player-module--date--57a15";
export var flex = "Player-module--flex--a4117";
export var spacer = "Player-module--spacer--16757";
export var svg = "Player-module--svg--419a0";